/* eslint-disable jira/filename-case */
import type { JiraLinkConfig } from '@jira/platform__routing-router-components/src/ui/router-link-config/index.tsx';

export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4Filters';
export const TEAM_NAME = 'jira-cosmos';

const createIssueNavigatorHref = (to: string): JiraLinkConfig => ({
	to,
	prefetch: 'hover',
});

export const FILTER_HREF = (filterId: string): JiraLinkConfig =>
	createIssueNavigatorHref(`/issues/?filter=${filterId}`);

export const SEARCH_ISSUES_HREF: JiraLinkConfig = createIssueNavigatorHref(
	'/issues/?jql=created%20%3E%3D%20-30d%20order%20by%20created%20DESC',
);
